import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const store = new Vuex.Store({
  state: {
    companyId: null,
    toggleSidebar: false
  },

  getters: {
    companyId(state) { return state.companyId },

    toggleSidebar: state => state.toggleSidebar,
  },

  mutations: {
    setCompanyId(state, payload) {
      state.companyId = payload
    },

    TOGGLE_SIDEBAR(state) {
      state.toggleSidebar = !state.toggleSidebar
    }
  },

  actions: {
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store.js